import React, { useEffect, useState } from "react";
import { Input } from "../../components/Input";
import { NextButton } from "../../components/NextButton";
import { Plan } from "../../components/Plan";
import { Page, Welcome, Register, Plans, Success } from "./styles";
import BasicSVG from "../../assets/Basic.svg";
import IntermediarieSVG from "../../assets/Intermediarie.svg";
import ComercialSVG from "../../assets/Comercial.svg";
import SuccessSVG from "../../assets/checked.png";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../services/api";
import { message } from "antd";
import { IClient } from "../Clients";
interface IUser {
  id: string;
  name: string;
  email: string;
  createdAt: Date;
}
const ClientRegister = () => {
  const navigate =useNavigate()
  const { id } = useParams();
  const [user, setUser] = useState<IUser>({} as IUser);
  const [render, setRender] = useState(0);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [corporateName, setCorporateName] = useState("");
  const [email, setEmail] = useState("");
  const [cpfCnpj, setCpfcnpj] = useState("");
  const [password, setPassword] = useState("");
  const [messageLimit, setMessageLimit] = useState(0);
  const [planSelected, setPlanSelected] = useState(0);
  function create(
    client: Omit<IClient, "id" | "createdAt" | "messageCount" | "isBlocked">, plan : number
  ) {
    setLoading(true);
    api
      .post<IClient>("clients/register", {...client, plan})
      .then(() => {
        nextStep();
        setTimeout(() => {  
          navigate("/login")
        }, 5000);
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => setLoading(false));
  }
  function handleAddDataClient() {
    if (!name|| !email || !cpfCnpj || !password || !corporateName) {
      return message.info("Por favor, preencha todos os campos.");
    }
    nextStep()

  }
  function handleCreateClient() {
    if (planSelected === 0) {
      return message.info("Por favor, selecione um dos planos.");
    }
    create({
      cpfCnpj: cpfCnpj,
      name,
      email,
      password,
      corporateName,
      messageLimit,
      userId: user.id,
    },
    planSelected
    );
  }
  function handleSelectPlan(value: number, plan: number) {
    setMessageLimit(value);
    setPlanSelected(plan)
  }
  function nextStep() {
    setRender((prevState) => prevState + 1);
  }
  function fetchData() {
    api
      .get<IUser>(`users/info/${id}`)
      .then((response) => {
        setUser(response.data);
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => setLoading(false));
  }
  function renderSwitch() {
    switch (render) {
      case 0:
        return (
          <Welcome>
            {loading ? (
              <>
                <h1>Bem vindo ao PipeGo - API</h1>
                <h2>Aguarde enquanto carregamos os dados...</h2>
              </>
            ) : (
              <>
                <h1>Bem vindo ao PipeGo - API</h1>
                <h2>
                  Vamos seguir com seu cadastro como cliente da{" "}
                  <span>{user.name}</span>.
                </h2>
              </>
            )}

            <NextButton onClick={nextStep} loading={loading}  />
          </Welcome>
        );
      case 1:
        return (
          <Register>
            <h1>Por favor, preencha todos os dados para prosseguir.</h1>
            <form>
              <div className="form-group">
                <span>*Nome:</span>
                <Input
                  placeholder="Digite um nome"
                  value={name}
                  onChange={(ev) => setName(ev.currentTarget.value)}
                />
              </div>
              <div className="form-group">
                <span>Nome Corporativo:</span>
                <Input
                  placeholder="Digite um nome corporativo"
                  value={corporateName}
                  onChange={(ev) => setCorporateName(ev.currentTarget.value)}
                />
              </div>
              <div className="form-group">
                <span>*Email:</span>
                <Input
                  placeholder="Digite um email"
                  value={email}
                  onChange={(ev) => setEmail(ev.currentTarget.value)}
                />
              </div>
              <div className="form-group">
                <span>CPF/CNPJ:</span>
                <Input
                  placeholder="Digite um CPF ou CNPJ"
                  value={cpfCnpj}
                  onChange={(ev) => setCpfcnpj(ev.currentTarget.value)}
                />
              </div>
              <div className="form-group">
                <span>*Senha:</span>
                <Input
                  placeholder="Digite uma senha"
                  value={password}
                  onChange={(ev) => setPassword(ev.currentTarget.value)}
                />
              </div>
            </form>
            <NextButton onClick={handleAddDataClient} />
          </Register>
        );
      case 2:
        return (
          <Plans>
            <h1>Por favor, escolha um de nossos planos.</h1>
            <div className="selection-plans">
              <Plan
                id={1}
                value={1000}
                title="Básico"
                price="R$ 200"
                icon={BasicSVG}
                attributes={["Dashboard", "500 Mensagens/Mês"]}
                onSelect={handleSelectPlan}
                isSelected={planSelected === 1}
              />
              <Plan
               id={2}
               value={2000}
                title="Intermediário"
                price="R$ 400"
                icon={IntermediarieSVG}
                attributes={["Dashboard", "2000 Mensagens/Mês"]}
                onSelect={handleSelectPlan}
                isSelected={planSelected === 2}
              />
              <Plan
               id={3}
               value={0}
                title="Comercial"
                price="Negociar"
                icon={ComercialSVG}
                attributes={["Dashboard", "500 Mensagens/Mês"]}
                onSelect={handleSelectPlan}
                isSelected={planSelected === 3}
              />
            </div>
            <NextButton onClick={handleCreateClient} loading={loading}  />
          </Plans>
        );
      case 3:
        return (
          <Success>
            <img alt="" src={SuccessSVG} />
            <h1>Obrigado!</h1>
            <h2>
              Enviaremos um boleto com o valor do plano selecionado para seu
              Email ou entraremos em contato no caso do plano comercial.
            </h2>
          </Success>
        );
      default:
        break;
    }
  }
  useEffect(fetchData, []);
  return <Page>{renderSwitch()}</Page>;
};
export { ClientRegister };
